import React, {Component} from 'react';
import {Col, Row, Tabs, Tab, FormControl} from 'react-bootstrap';
import config from  '../../../config';
import json2csv   from 'json2csv'
import moment   from 'moment'
import Select   from 'react-select'
import {} from "actions/actionTypes";
import {prepareSelectOptionsList, filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';

const allReportFieldList = [
    {label: 'Location', value:'ContractorID.MarketName'},
    {label: 'Worker', value:'FullName'},
    {label: 'Comment', value:'Comment'},
    // {label: 'First Name', value:'UserID.firstName'},
    // {label: 'Last Name', value:'UserID.lastName'},
    // {label: 'Worker Type', value: 'ContractorID.Type'},
    // {label: 'Payment Method', value: 'ContractorID.PaymentMethod'},
     {label: 'Started At', value:'StartTime'},
    {label: 'Ended At', value:'EndTime'},
    {label: 'Duration', value:'Duration'},
    {label: 'Pay Rate', value:'HourlyRate'},
    {label: 'Status', value:'Status'},
    //{label: 'ProductsAdded', value:'ProductsAdded'},
]

export default class AdminUserTimeTrackingActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
            pending: false,
            reportFields:allReportFieldList
        };

    };


    downloadReport(){
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        this.props.makeRequest({'records': this.props.adminUsersData.selectedRecords, reportType:'users_working_time' }, methodData).then(res => {
            var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })
            var dataToExport = _.map(res.data, function (workingData) {
                console.log('workingData', workingData  );
                workingData.StartTime = moment(workingData.StartTime).format('MM-DD-YYYY HH:mm')
                workingData.EndTime = moment(workingData.EndTime).format('MM-DD-YYYY HH:mm')
                workingData.Duration = moment.utc(workingData.Duration).format('HH:mm')
                workingData.FullName =_.get(workingData,'UserID.firstName','') + ' ' + _.get(workingData,'UserID.lastName','')
                workingData.Status =_.startCase(workingData.Status)

                // if (-1 !== _.find(fields, function (o) {
                //         o.value == 'ProductsLinks'
                //     })) {
                //     workingData.ProductsLinks = _.map(_.get(workingData, ['ProductsAdded'], []), function (productAdded, key) {
                //
                //         return config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]", _.get(productAdded, ['ProductID', 'ShopifyProductID'], '1111111111'))
                //     })
                //     if (-1 !== _.find(fields, function (o) {
                //             o.value == 'ProductsAddedNumber'
                //         })) {
                //         workingData.ProductsAddedNumber = _.get(workingData, ['ProductsAdded'], []).length
                //     }
                // }
                return workingData
            })

console.log('dataToExport',dataToExport );
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
                unwindPath:[ 'UserID', 'ContractorID']
            })

            var filename = "working_time_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            console.log('err', err );
        });
    }
    onSelectTab(event){
        this.setState({displayReportTab:!this.state.displayReportTab})
    }

    render() {


        return (
            <div className="top20">
                <Tabs defaultActiveKey={''}  onSelect={(e)=>{this.onSelectTab(e)}} id="userActionBox" >
                    <Tab eventKey={'reports'}  className= {this.state.displayReportTab ? '':'hidden'} unmountOnExit={true} title="Reports" >
                        <Row >
                            <Col md={4} xs={4} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable ={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions)=> this.setState({'reportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.reportFields}
                                />
                            </Col>

                        </Row>
                        <Row>
                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending} onClick={ this.downloadReport.bind(this)}
                                        type="button">
                                    Download report
                                </button>
                            </Col>

                        </Row>
                    </Tab>

                </Tabs>
            </div>
        );

    }
}



